import React from 'react';
import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded';
import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import NorthEastRounded from '@mui/icons-material/NorthEastRounded';
import GroupOutlined from '@mui/icons-material/GroupOutlined';
import MailOutlineRounded from '@mui/icons-material/MailOutlineRounded';
import GridViewRounded from '@mui/icons-material/GridViewRounded';
import HistoryRounded from '@mui/icons-material/HistoryRounded';
import AddRounded from '@mui/icons-material/AddRounded';
import SearchRounded from '@mui/icons-material/SearchRounded';
import CloseRounded from '@mui/icons-material/CloseRounded';
import CheckRounded from '@mui/icons-material/CheckRounded';
import LogoutRounded from '@mui/icons-material/LogoutRounded';
import EditOutlined from '@mui/icons-material/EditOutlined';
import VerifiedUserOutlined from '@mui/icons-material/VerifiedUserOutlined';
import LocalFireDepartmentOutlined from '@mui/icons-material/LocalFireDepartmentOutlined';
import RestaurantRounded from '@mui/icons-material/RestaurantRounded';
import SupportAgentRounded from '@mui/icons-material/SupportAgentRounded';
import BeachAccessRounded from '@mui/icons-material/BeachAccessRounded';
import HotelRounded from '@mui/icons-material/HotelRounded';
import CodeRounded from '@mui/icons-material/CodeRounded';
import HubRounded from '@mui/icons-material/HubRounded';
import HomeRounded from '@mui/icons-material/HomeRounded';
const icons = { arrow: ArrowForwardRounded, back: ArrowBackRounded, diagonal: NorthEastRounded, people: GroupOutlined, mail: MailOutlineRounded, grid: GridViewRounded, history: HistoryRounded, plus: AddRounded, search: SearchRounded, close: CloseRounded, check: CheckRounded, logout: LogoutRounded, edit: EditOutlined, shield: VerifiedUserOutlined, flame: LocalFireDepartmentOutlined };
export default function Icon({ name, size = 20, sx, ...props }) {
  const MaterialIcon = ({ kitchen:RestaurantRounded, support:SupportAgentRounded, beach:BeachAccessRounded, hotel:HotelRounded, code:CodeRounded, hub:HubRounded, home:HomeRounded })[name] || icons[name] || ArrowForwardRounded;
  return <MaterialIcon sx={{ fontSize: size, ...sx }} aria-hidden="true" {...props} />;
}
